// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_best_selling = /** @type {(inputs: {}) => string} */ () => {
	return `best selling`
};

const el_best_selling = /** @type {(inputs: {}) => string} */ () => {
	return `δημοφιλέστερα`
};

const ru_best_selling = /** @type {(inputs: {}) => string} */ () => {
	return `популярные`
};

const he_best_selling = /** @type {(inputs: {}) => string} */ () => {
	return `הנמכרים ביותר`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const best_selling = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.best_selling(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("best_selling", locale)
	if (locale === "en") return en_best_selling(inputs)
	if (locale === "el") return el_best_selling(inputs)
	if (locale === "ru") return ru_best_selling(inputs)
	if (locale === "he") return he_best_selling(inputs)
	return "best_selling"
};